import { render, staticRenderFns } from "./salary-send-modify-componet.vue?vue&type=template&id=4f9c04e7&scoped=true&"
import script from "./salary-send-modify-componet.vue?vue&type=script&lang=js&"
export * from "./salary-send-modify-componet.vue?vue&type=script&lang=js&"
import style0 from "./salary-send-modify-componet.vue?vue&type=style&index=0&id=4f9c04e7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9c04e7",
  null
  
)

export default component.exports